import { store } from '../../store';
let pollingInterval = null;
export const startPolling = (pollingFunction, // Pass the background flag
interval = 20000) => {
    // Clear any existing interval
    if (pollingInterval) {
        clearInterval(pollingInterval);
    }
    const poll = async () => {
        try {
            await store.dispatch(() => pollingFunction({ background: true }));
            //await store.dispatch(pollingFunction({ background: true })); // Dispatch with background flag
        }
        catch (error) {
            console.error('Error during polling:', error);
        }
    };
    poll(); // Call immediately to initiate the first polling
    pollingInterval = setInterval(poll, interval); // Call at regular intervals
};
export const stopPolling = () => {
    if (pollingInterval) {
        clearInterval(pollingInterval);
        pollingInterval = null;
    }
};
